import { apiBaseUrlConfig } from ".";

export const myPoliciesUrl = `${apiBaseUrlConfig}/casbin-policy/my-policies`;

